/**
 * Canvas Playground is an internal developer tool.
 * Allowed when:
 *  - NODE_ENV !== 'production', or
 *  - REACT_APP_ENABLE_CANVAS_PLAYGROUND=true, or
 *  - localStorage workload_internal_dev=1 (explicit internal opt-in)
 */
export function isCanvasPlaygroundAllowed() {
  if (process.env.REACT_APP_ENABLE_CANVAS_PLAYGROUND === 'true') return true;
  if (process.env.NODE_ENV !== 'production') return true;
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem('workload_internal_dev') === '1') {
      return true;
    }
  } catch (_) {
    /* ignore */
  }
  return false;
}
